var React = require('react');

function MusicalNote (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(3 2.215)","stroke":"#1A68BF","strokeWidth":"4.68","fill":"none","fillRule":"evenodd"},[React.createElement("ellipse",{"cx":"9.18","cy":"52.56","rx":"9.18","ry":"9.36","key":0}),React.createElement("ellipse",{"cx":"49.14","cy":"43.2","rx":"9.18","ry":"9.36","key":1}),React.createElement("path",{"d":"M18.36 48.96V9.467a.36.36 0 01.28-.351L57.88.1a.36.36 0 01.44.351V39.78h0","strokeLinecap":"square","key":2}),React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M18.36 21.6l39.96-9.36","key":3})]));
}

MusicalNote.defaultProps = {"width":"64","height":"67"};

module.exports = MusicalNote;

MusicalNote.default = MusicalNote;
